import { networkService } from '@/services/network.service';
import OfflineLogger from '@/utils/offlineLogger';

export type SyncEventCallback = (status: string) => void;

export class SyncEventEmitter {
  private listeners: SyncEventCallback[] = [];

  addListener(callback: SyncEventCallback): () => void {
    this.listeners.push(callback);
    return () => {
      const index = this.listeners.indexOf(callback);
      if (index > -1) {
        this.listeners.splice(index, 1);
      }
    };
  }

  emit(status: string): void {
    this.listeners.forEach(cb => {
      try {
        cb(status);
      } catch (error) {
        OfflineLogger.error('SyncEventEmitter.emit', error);
      }
    });
  }

  clear(): void {
    this.listeners = [];
  }
}

export function setupNetworkListener(callback: () => void): () => void {
  return networkService.addListener(status => {
    if (status.connected) {
      setTimeout(callback, 2000);
    }
  });
}

export function setupPageVisibilityListener(callback: () => void): void {
  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        callback();
      }
    });
  }
}

export function setupPeriodicSync(interval: number, callback: () => void): NodeJS.Timeout {
  return setInterval(callback, interval);
}
